import psList from "ps-list";
/** Default provider backed by ps-list; cmd/path availability varies by platform. */
export class PsListProcessProvider {
    /**
     * ps-list does not expose a dedicated path field; callers may parse cmd.
     */
    async list() {
        const processes = await psList({ all: true });
        return processes.map((proc) => ({
            pid: proc.pid,
            ppid: proc.ppid,
            name: proc.name,
            cmd: proc.cmd,
            // ps-list doesn't provide a 'path' property; it must be derived from 'cmd'
        }));
    }
}
export const defaultProcessProvider = new PsListProcessProvider();
